import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_mails_proto from './dcei_wildsky_mails_proto';
class SubscriptionData_AutoMail_RepeatMode {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "ONE_TIME": return 0;
        case "DAILY": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return SubscriptionData_AutoMail_RepeatMode.fromJson(value);
  }
  static fromReact(e) {
    return SubscriptionData_AutoMail_RepeatMode.fromJson(e);
  }
}
SubscriptionData_AutoMail_RepeatMode.ONE_TIME = 0;
SubscriptionData_AutoMail_RepeatMode.DAILY = 1;
SubscriptionData_AutoMail_RepeatMode.default = 0;
SubscriptionData_AutoMail_RepeatMode.values = {
  ONE_TIME: 0,
  DAILY: 1,
};
SubscriptionData_AutoMail_RepeatMode.names = {
  0: "ONE_TIME",
  1: "DAILY",
};
class SubscriptionData_AutoMail {
  get descriptor() {
    return SubscriptionData_AutoMail.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasId = false;
    this._id = null;
    this._hasMailKey = false;
    this._mailKey = null;
    this._hasRepeatMode = false;
    this._repeatMode = null;
    this._hasResetTime = false;
    this._resetTime = null;
    this._hasAttachments = false;
    this._attachments = null;
  }
  isEmpty() {
    if (this._hasId) return false;
    if (this._hasMailKey) return false;
    if (this._hasRepeatMode) return false;
    if (this._hasResetTime) return false;
    if (this._hasAttachments && !this._attachments.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SubscriptionData_AutoMail) {
      return value;
    }
    return SubscriptionData_AutoMail.fromJson(value);
  }
  static fromJson(json) {
    const result = new SubscriptionData_AutoMail();
    if (json.id != null) {
      result._hasId = true;
      result._id = JsonToString.fromJson(json.id);
    }
    if (json.mailKey != null) {
      result._hasMailKey = true;
      result._mailKey = JsonToString.fromJson(json.mailKey);
    }
    if (json.repeatMode != null) {
      result._hasRepeatMode = true;
      result._repeatMode = SubscriptionData_AutoMail_RepeatMode.fromJson(json.repeatMode);
    }
    if (json.resetTime != null) {
      result._hasResetTime = true;
      result._resetTime = JsonToInt32.fromJson(json.resetTime);
    }
    if (json.attachments != null) {
      result._hasAttachments = true;
      result._attachments = dcei_wildsky_mails_proto.Mail.MailAttachments.fromJson(json.attachments);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasId) {
      result.id = JsonToString.toJson(this._id);
    }
    if (this._hasMailKey) {
      result.mailKey = JsonToString.toJson(this._mailKey);
    }
    if (this._hasRepeatMode) {
      result.repeatMode = SubscriptionData_AutoMail_RepeatMode.toJson(this._repeatMode);
    }
    if (this._hasResetTime) {
      result.resetTime = JsonToInt32.toJson(this._resetTime);
    }
    if (this._hasAttachments && !this._attachments.isEmpty()) {
      result.attachments = dcei_wildsky_mails_proto.Mail.MailAttachments.toJson(this._attachments);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get id() {
    return this._hasId ? this._id : JsonToString.default;
  }
  get hasId() {
    return this._hasId;
  }
  setId(path, value) {
    return {type: 'SET', path: path.concat(['id']), value};
  }
  deleteId(path) {
    return {type: 'DELETE', path: path.concat(['id'])};
  }
  /**
   * @returns {string}
   */
  get mailKey() {
    return this._hasMailKey ? this._mailKey : JsonToString.default;
  }
  get hasMailKey() {
    return this._hasMailKey;
  }
  setMailKey(path, value) {
    return {type: 'SET', path: path.concat(['mailKey']), value};
  }
  deleteMailKey(path) {
    return {type: 'DELETE', path: path.concat(['mailKey'])};
  }
  /**
   * @returns {number}
   */
  get repeatMode() {
    return this._hasRepeatMode ? this._repeatMode : SubscriptionData_AutoMail_RepeatMode.default;
  }
  get hasRepeatMode() {
    return this._hasRepeatMode;
  }
  setRepeatMode(path, value) {
    return {type: 'SET', path: path.concat(['repeatMode']), value};
  }
  deleteRepeatMode(path) {
    return {type: 'DELETE', path: path.concat(['repeatMode'])};
  }
  /**
   * @returns {number}
   */
  get resetTime() {
    return this._hasResetTime ? this._resetTime : JsonToInt32.default;
  }
  get hasResetTime() {
    return this._hasResetTime;
  }
  setResetTime(path, value) {
    return {type: 'SET', path: path.concat(['resetTime']), value};
  }
  deleteResetTime(path) {
    return {type: 'DELETE', path: path.concat(['resetTime'])};
  }
  /**
   * @returns {dcei_wildsky_mails_proto.Mail.MailAttachments}
   */
  get attachments() {
    return this._hasAttachments ? this._attachments : dcei_wildsky_mails_proto.Mail.MailAttachments.default;
  }
  get hasAttachments() {
    return this._hasAttachments;
  }
  setAttachments(path, value) {
    return {type: 'SET', path: path.concat(['attachments']), value: value.toJson()};
  }
  deleteAttachments(path) {
    return {type: 'DELETE', path: path.concat(['attachments'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "id": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubscriptionData_AutoMail(this);
              copy._hasId = true;
              copy._id = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasId) {
                return this;
              }
              const copy = new SubscriptionData_AutoMail(this);
              copy._hasId = false;
              copy._id = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "mailKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubscriptionData_AutoMail(this);
              copy._hasMailKey = true;
              copy._mailKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMailKey) {
                return this;
              }
              const copy = new SubscriptionData_AutoMail(this);
              copy._hasMailKey = false;
              copy._mailKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "repeatMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubscriptionData_AutoMail(this);
              copy._hasRepeatMode = true;
              copy._repeatMode = SubscriptionData_AutoMail_RepeatMode.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRepeatMode) {
                return this;
              }
              const copy = new SubscriptionData_AutoMail(this);
              copy._hasRepeatMode = false;
              copy._repeatMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "resetTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubscriptionData_AutoMail(this);
              copy._hasResetTime = true;
              copy._resetTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasResetTime) {
                return this;
              }
              const copy = new SubscriptionData_AutoMail(this);
              copy._hasResetTime = false;
              copy._resetTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "attachments": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubscriptionData_AutoMail(this);
              copy._hasAttachments = true;
              copy._attachments = dcei_wildsky_mails_proto.Mail.MailAttachments.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAttachments) {
                return this;
              }
              const copy = new SubscriptionData_AutoMail(this);
              copy._hasAttachments = false;
              copy._attachments = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasAttachments) {
            const copy = new SubscriptionData_AutoMail(this);
            copy._hasAttachments = true;
            copy._attachments = dcei_wildsky_mails_proto.Mail.MailAttachments.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._attachments.apply(type, path.slice(1), value);
          if (newValue === this._attachments) {
            return this;
          }
          const copy = new SubscriptionData_AutoMail(this);
          copy._attachments = copy._attachments.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SubscriptionData_AutoMail} other
   * @returns {SubscriptionData_AutoMail}
   */
  merge(other) {
    const copy = new SubscriptionData_AutoMail(this);
    if (other._hasId) {
      copy._hasId = true;
      copy._id = other._id;
    }
    if (other._hasMailKey) {
      copy._hasMailKey = true;
      copy._mailKey = other._mailKey;
    }
    if (other._hasRepeatMode) {
      copy._hasRepeatMode = true;
      copy._repeatMode = other._repeatMode;
    }
    if (other._hasResetTime) {
      copy._hasResetTime = true;
      copy._resetTime = other._resetTime;
    }
    if (other._hasAttachments) {
      if (copy._hasAttachments) {
        copy._attachments = copy.attachments.merge(other.attachments);
      } else {
        copy._attachments = other._attachments;
      }
      copy._hasAttachments = true;
    }
    return copy;
  }
}
SubscriptionData_AutoMail.default = new SubscriptionData_AutoMail();
SubscriptionData_AutoMail.RepeatMode = SubscriptionData_AutoMail_RepeatMode;
class SubscriptionData_AutoMail_Builder {
  constructor(value) {
    this._value = new SubscriptionData_AutoMail(value);
  }
  build() {
    return new SubscriptionData_AutoMail(this._value);
  }
  setId(value) {
    this._value._hasId = true;
    this._value._id = value;
    return this;
  }
  deleteId() {
    this._value._hasId = false;
    this._value._id = null;
    return this;
  }
  setMailKey(value) {
    this._value._hasMailKey = true;
    this._value._mailKey = value;
    return this;
  }
  deleteMailKey() {
    this._value._hasMailKey = false;
    this._value._mailKey = null;
    return this;
  }
  setRepeatMode(value) {
    this._value._hasRepeatMode = true;
    this._value._repeatMode = value;
    return this;
  }
  deleteRepeatMode() {
    this._value._hasRepeatMode = false;
    this._value._repeatMode = null;
    return this;
  }
  setResetTime(value) {
    this._value._hasResetTime = true;
    this._value._resetTime = value;
    return this;
  }
  deleteResetTime() {
    this._value._hasResetTime = false;
    this._value._resetTime = null;
    return this;
  }
  setAttachments(value) {
    this._value._hasAttachments = true;
    this._value._attachments = value;
    return this;
  }
  deleteAttachments() {
    this._value._hasAttachments = false;
    this._value._attachments = null;
    return this;
  }
}
SubscriptionData_AutoMail.Builder = SubscriptionData_AutoMail_Builder;
class SubscriptionData_AutoMail_WithParent {
  /**
   * @param {SubscriptionData_AutoMail} value
   * @param {SubscriptionData_AutoMail_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SubscriptionData_AutoMail.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasId() {
    if (this._cachedHasId === undefined) {
      if (this._value.hasId) {
        this._cachedHasId = true;
      } else {
        this._cachedHasId = this._parent ? this._parent.hasId : false;
      }
    }
    return this._cachedHasId;
  }
  get id() {
    if (this._cachedId === undefined) {
      if (this._value.hasId) {
        this._cachedId = this._value.id;
      } else {
        this._cachedId = this._parent ? this._parent.id : this._value.id;
      }
    }
    return this._cachedId;
  }
  get hasMailKey() {
    if (this._cachedHasMailKey === undefined) {
      if (this._value.hasMailKey) {
        this._cachedHasMailKey = true;
      } else {
        this._cachedHasMailKey = this._parent ? this._parent.hasMailKey : false;
      }
    }
    return this._cachedHasMailKey;
  }
  get mailKey() {
    if (this._cachedMailKey === undefined) {
      if (this._value.hasMailKey) {
        this._cachedMailKey = this._value.mailKey;
      } else {
        this._cachedMailKey = this._parent ? this._parent.mailKey : this._value.mailKey;
      }
    }
    return this._cachedMailKey;
  }
  get hasRepeatMode() {
    if (this._cachedHasRepeatMode === undefined) {
      if (this._value.hasRepeatMode) {
        this._cachedHasRepeatMode = true;
      } else {
        this._cachedHasRepeatMode = this._parent ? this._parent.hasRepeatMode : false;
      }
    }
    return this._cachedHasRepeatMode;
  }
  get repeatMode() {
    if (this._cachedRepeatMode === undefined) {
      if (this._value.hasRepeatMode) {
        this._cachedRepeatMode = this._value.repeatMode;
      } else {
        this._cachedRepeatMode = this._parent ? this._parent.repeatMode : this._value.repeatMode;
      }
    }
    return this._cachedRepeatMode;
  }
  get hasResetTime() {
    if (this._cachedHasResetTime === undefined) {
      if (this._value.hasResetTime) {
        this._cachedHasResetTime = true;
      } else {
        this._cachedHasResetTime = this._parent ? this._parent.hasResetTime : false;
      }
    }
    return this._cachedHasResetTime;
  }
  get resetTime() {
    if (this._cachedResetTime === undefined) {
      if (this._value.hasResetTime) {
        this._cachedResetTime = this._value.resetTime;
      } else {
        this._cachedResetTime = this._parent ? this._parent.resetTime : this._value.resetTime;
      }
    }
    return this._cachedResetTime;
  }
  get hasAttachments() {
    if (this._cachedHasAttachments === undefined) {
      if (this._value.hasAttachments) {
        this._cachedHasAttachments = true;
      } else {
        this._cachedHasAttachments = this._parent ? this._parent.hasAttachments : false;
      }
    }
    return this._cachedHasAttachments;
  }
  get attachments() {
    if (!this._cachedAttachments) {
      if (this._value.hasAttachments) {
        this._cachedAttachments = new dcei_wildsky_mails_proto.Mail.MailAttachments.WithParent(this._value.attachments, this._parent && this._parent.hasAttachments ? this._parent.attachments : null);
      } else {
        this._cachedAttachments = this._parent ? new dcei_wildsky_mails_proto.Mail.MailAttachments.WithParent(dcei_wildsky_mails_proto.Mail.MailAttachments.default, this._parent.attachments) : dcei_wildsky_mails_proto.Mail.MailAttachments.WithParent.default;
      }
    }
    return this._cachedAttachments;
  }
  update(current, parent) {
    const result = new SubscriptionData_AutoMail_WithParent(current, parent);
    if (this._cachedAttachments && this._value.hasAttachments && current.hasAttachments) {
      if (this._value.attachments === current.attachments && this._parent === parent) {
        result._cachedAttachments = this._cachedAttachments;
      } else {
        result._cachedAttachments = this._cachedAttachments.update(current.attachments, parent && parent.hasAttachments ? parent.attachments : null);
      }
    }
    return result;
  }
}
SubscriptionData_AutoMail_WithParent.default = new SubscriptionData_AutoMail_WithParent(SubscriptionData_AutoMail.default, null);
SubscriptionData_AutoMail.WithParent = SubscriptionData_AutoMail_WithParent;
class SubscriptionData_AutoMail_Descriptor {
  get id() {
    if (!this._id) {
      this._id = {
        name: "id",
        Name: "Id",
        number: 1,
        protoType: 9,
        protoName: "id",
        type: JsonToString,
        options: {
          comments: "Used for server to identify this mail to track records",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._id;
  }
  get mailKey() {
    if (!this._mailKey) {
      this._mailKey = {
        name: "mailKey",
        Name: "MailKey",
        number: 2,
        protoType: 9,
        protoName: "mail_key",
        type: JsonToString,
        options: {
          valueDropdown: "MailKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mailKey;
  }
  get repeatMode() {
    if (!this._repeatMode) {
      this._repeatMode = {
        name: "repeatMode",
        Name: "RepeatMode",
        number: 3,
        protoType: 14,
        protoName: "repeat_mode",
        type: SubscriptionData_AutoMail_RepeatMode,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._repeatMode;
  }
  get resetTime() {
    if (!this._resetTime) {
      this._resetTime = {
        name: "resetTime",
        Name: "ResetTime",
        number: 4,
        protoType: 5,
        protoName: "reset_time",
        type: JsonToInt32,
        options: {
          comments: "If mode is ONE_TIME, this will be ignored If mode is DAILY, this is time in seconds passed from midnight",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._resetTime;
  }
  get attachments() {
    if (!this._attachments) {
      this._attachments = {
        name: "attachments",
        Name: "Attachments",
        number: 5,
        protoType: 11,
        protoName: "attachments",
        type: dcei_wildsky_mails_proto.Mail.MailAttachments,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._attachments;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.id,
        this.mailKey,
        this.repeatMode,
        this.resetTime,
        this.attachments,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForId",
        Name: "DummyOneofForId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMailKey",
        Name: "DummyOneofForMailKey",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRepeatMode",
        Name: "DummyOneofForRepeatMode",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForResetTime",
        Name: "DummyOneofForResetTime",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAttachments",
        Name: "DummyOneofForAttachments",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
SubscriptionData_AutoMail.descriptor = new SubscriptionData_AutoMail_Descriptor();
class SubscriptionData_Subscription {
  get descriptor() {
    return SubscriptionData_Subscription.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._hasDuration = false;
    this._duration = null;
    this._autoMails = [];
    this._hasElementalTrialExtraPurchases = false;
    this._elementalTrialExtraPurchases = null;
    this._hasSkillPointsExtraRefills = false;
    this._skillPointsExtraRefills = null;
    this._hasExtendable = false;
    this._extendable = null;
    this._hasPersistent = false;
    this._persistent = null;
    this._hasElementalTrialFeatureRewardCount = false;
    this._elementalTrialFeatureRewardCount = null;
    this._hasMineFastClaimCount = false;
    this._mineFastClaimCount = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasDisplayName) return false;
    if (this._hasDuration) return false;
    if (this._autoMails.length > 0) return false;
    if (this._hasElementalTrialExtraPurchases) return false;
    if (this._hasSkillPointsExtraRefills) return false;
    if (this._hasExtendable) return false;
    if (this._hasPersistent) return false;
    if (this._hasElementalTrialFeatureRewardCount) return false;
    if (this._hasMineFastClaimCount) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SubscriptionData_Subscription) {
      return value;
    }
    return SubscriptionData_Subscription.fromJson(value);
  }
  static fromJson(json) {
    const result = new SubscriptionData_Subscription();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    if (json.duration != null) {
      result._hasDuration = true;
      result._duration = JsonToInt32.fromJson(json.duration);
    }
    result._autoMails = JsonToList(json.autoMails, SubscriptionData_AutoMail);
    if (json.elementalTrialExtraPurchases != null) {
      result._hasElementalTrialExtraPurchases = true;
      result._elementalTrialExtraPurchases = JsonToInt32.fromJson(json.elementalTrialExtraPurchases);
    }
    if (json.skillPointsExtraRefills != null) {
      result._hasSkillPointsExtraRefills = true;
      result._skillPointsExtraRefills = JsonToInt32.fromJson(json.skillPointsExtraRefills);
    }
    if (json.extendable != null) {
      result._hasExtendable = true;
      result._extendable = JsonToBoolean.fromJson(json.extendable);
    }
    if (json.persistent != null) {
      result._hasPersistent = true;
      result._persistent = JsonToBoolean.fromJson(json.persistent);
    }
    if (json.elementalTrialFeatureRewardCount != null) {
      result._hasElementalTrialFeatureRewardCount = true;
      result._elementalTrialFeatureRewardCount = JsonToInt32.fromJson(json.elementalTrialFeatureRewardCount);
    }
    if (json.mineFastClaimCount != null) {
      result._hasMineFastClaimCount = true;
      result._mineFastClaimCount = JsonToInt32.fromJson(json.mineFastClaimCount);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._hasDuration) {
      result.duration = JsonToInt32.toJson(this._duration);
    }
    if (this._autoMails.length > 0) {
      result.autoMails = ArrayToJson(this._autoMails, SubscriptionData_AutoMail);
    }
    if (this._hasElementalTrialExtraPurchases) {
      result.elementalTrialExtraPurchases = JsonToInt32.toJson(this._elementalTrialExtraPurchases);
    }
    if (this._hasSkillPointsExtraRefills) {
      result.skillPointsExtraRefills = JsonToInt32.toJson(this._skillPointsExtraRefills);
    }
    if (this._hasExtendable) {
      result.extendable = JsonToBoolean.toJson(this._extendable);
    }
    if (this._hasPersistent) {
      result.persistent = JsonToBoolean.toJson(this._persistent);
    }
    if (this._hasElementalTrialFeatureRewardCount) {
      result.elementalTrialFeatureRewardCount = JsonToInt32.toJson(this._elementalTrialFeatureRewardCount);
    }
    if (this._hasMineFastClaimCount) {
      result.mineFastClaimCount = JsonToInt32.toJson(this._mineFastClaimCount);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {number}
   */
  get duration() {
    return this._hasDuration ? this._duration : JsonToInt32.default;
  }
  get hasDuration() {
    return this._hasDuration;
  }
  setDuration(path, value) {
    return {type: 'SET', path: path.concat(['duration']), value};
  }
  deleteDuration(path) {
    return {type: 'DELETE', path: path.concat(['duration'])};
  }
  /**
   * @returns {SubscriptionData_AutoMail[]}
   */
  get autoMails() {
    return this._autoMails;
  }
  addAutoMails(path, value) {
    return {type: 'ADD', path: path.concat(['autoMails']), value: value.toJson()};
  }
  setAutoMails(path, value) {
    return {type: 'SET', path: path.concat(['autoMails']), value: ArrayToJson(value, SubscriptionData_AutoMail)};
  }
  setAutoMailsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['autoMails', key]), value: value.toJson()};
  }
  deleteAutoMails(path) {
    return {type: 'DELETE', path: path.concat(['autoMails'])};
  }
  deleteAutoMailsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['autoMails', key])};
  }
  /**
   * @returns {number}
   */
  get elementalTrialExtraPurchases() {
    return this._hasElementalTrialExtraPurchases ? this._elementalTrialExtraPurchases : JsonToInt32.default;
  }
  get hasElementalTrialExtraPurchases() {
    return this._hasElementalTrialExtraPurchases;
  }
  setElementalTrialExtraPurchases(path, value) {
    return {type: 'SET', path: path.concat(['elementalTrialExtraPurchases']), value};
  }
  deleteElementalTrialExtraPurchases(path) {
    return {type: 'DELETE', path: path.concat(['elementalTrialExtraPurchases'])};
  }
  /**
   * @returns {number}
   */
  get skillPointsExtraRefills() {
    return this._hasSkillPointsExtraRefills ? this._skillPointsExtraRefills : JsonToInt32.default;
  }
  get hasSkillPointsExtraRefills() {
    return this._hasSkillPointsExtraRefills;
  }
  setSkillPointsExtraRefills(path, value) {
    return {type: 'SET', path: path.concat(['skillPointsExtraRefills']), value};
  }
  deleteSkillPointsExtraRefills(path) {
    return {type: 'DELETE', path: path.concat(['skillPointsExtraRefills'])};
  }
  /**
   * @returns {boolean}
   */
  get extendable() {
    return this._hasExtendable ? this._extendable : JsonToBoolean.default;
  }
  get hasExtendable() {
    return this._hasExtendable;
  }
  setExtendable(path, value) {
    return {type: 'SET', path: path.concat(['extendable']), value};
  }
  deleteExtendable(path) {
    return {type: 'DELETE', path: path.concat(['extendable'])};
  }
  /**
   * @returns {boolean}
   */
  get persistent() {
    return this._hasPersistent ? this._persistent : JsonToBoolean.default;
  }
  get hasPersistent() {
    return this._hasPersistent;
  }
  setPersistent(path, value) {
    return {type: 'SET', path: path.concat(['persistent']), value};
  }
  deletePersistent(path) {
    return {type: 'DELETE', path: path.concat(['persistent'])};
  }
  /**
   * @returns {number}
   */
  get elementalTrialFeatureRewardCount() {
    return this._hasElementalTrialFeatureRewardCount ? this._elementalTrialFeatureRewardCount : JsonToInt32.default;
  }
  get hasElementalTrialFeatureRewardCount() {
    return this._hasElementalTrialFeatureRewardCount;
  }
  setElementalTrialFeatureRewardCount(path, value) {
    return {type: 'SET', path: path.concat(['elementalTrialFeatureRewardCount']), value};
  }
  deleteElementalTrialFeatureRewardCount(path) {
    return {type: 'DELETE', path: path.concat(['elementalTrialFeatureRewardCount'])};
  }
  /**
   * @returns {number}
   */
  get mineFastClaimCount() {
    return this._hasMineFastClaimCount ? this._mineFastClaimCount : JsonToInt32.default;
  }
  get hasMineFastClaimCount() {
    return this._hasMineFastClaimCount;
  }
  setMineFastClaimCount(path, value) {
    return {type: 'SET', path: path.concat(['mineFastClaimCount']), value};
  }
  deleteMineFastClaimCount(path) {
    return {type: 'DELETE', path: path.concat(['mineFastClaimCount'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubscriptionData_Subscription(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new SubscriptionData_Subscription(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubscriptionData_Subscription(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new SubscriptionData_Subscription(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "duration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubscriptionData_Subscription(this);
              copy._hasDuration = true;
              copy._duration = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDuration) {
                return this;
              }
              const copy = new SubscriptionData_Subscription(this);
              copy._hasDuration = false;
              copy._duration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "autoMails": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubscriptionData_Subscription(this);
              copy._autoMails = [];        for (let i of value) {
                copy._autoMails.push(SubscriptionData_AutoMail.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new SubscriptionData_Subscription(this);
              copy._autoMails = copy._autoMails.concat([SubscriptionData_AutoMail.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._autoMails.length === 0) {
                return this;
              }
              const copy = new SubscriptionData_Subscription(this);
              copy._autoMails = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._autoMails.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new SubscriptionData_Subscription(this);
              copy._autoMails = copy._autoMails.slice();
              copy._autoMails[path[1]] = SubscriptionData_AutoMail.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new SubscriptionData_Subscription(this);
              copy._autoMails = copy._autoMails.slice(0, path[1]).concat(copy._autoMails.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._autoMails.length) {
            return this;
          }
          const oldValue = this._autoMails[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new SubscriptionData_Subscription(this);
          copy._autoMails = copy._autoMails.slice();
          copy._autoMails[key] = newValue;
          return copy;
        }
      }
      case "elementalTrialExtraPurchases": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubscriptionData_Subscription(this);
              copy._hasElementalTrialExtraPurchases = true;
              copy._elementalTrialExtraPurchases = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasElementalTrialExtraPurchases) {
                return this;
              }
              const copy = new SubscriptionData_Subscription(this);
              copy._hasElementalTrialExtraPurchases = false;
              copy._elementalTrialExtraPurchases = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "skillPointsExtraRefills": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubscriptionData_Subscription(this);
              copy._hasSkillPointsExtraRefills = true;
              copy._skillPointsExtraRefills = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSkillPointsExtraRefills) {
                return this;
              }
              const copy = new SubscriptionData_Subscription(this);
              copy._hasSkillPointsExtraRefills = false;
              copy._skillPointsExtraRefills = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "extendable": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubscriptionData_Subscription(this);
              copy._hasExtendable = true;
              copy._extendable = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasExtendable) {
                return this;
              }
              const copy = new SubscriptionData_Subscription(this);
              copy._hasExtendable = false;
              copy._extendable = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "persistent": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubscriptionData_Subscription(this);
              copy._hasPersistent = true;
              copy._persistent = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPersistent) {
                return this;
              }
              const copy = new SubscriptionData_Subscription(this);
              copy._hasPersistent = false;
              copy._persistent = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "elementalTrialFeatureRewardCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubscriptionData_Subscription(this);
              copy._hasElementalTrialFeatureRewardCount = true;
              copy._elementalTrialFeatureRewardCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasElementalTrialFeatureRewardCount) {
                return this;
              }
              const copy = new SubscriptionData_Subscription(this);
              copy._hasElementalTrialFeatureRewardCount = false;
              copy._elementalTrialFeatureRewardCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "mineFastClaimCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubscriptionData_Subscription(this);
              copy._hasMineFastClaimCount = true;
              copy._mineFastClaimCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMineFastClaimCount) {
                return this;
              }
              const copy = new SubscriptionData_Subscription(this);
              copy._hasMineFastClaimCount = false;
              copy._mineFastClaimCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SubscriptionData_Subscription} other
   * @returns {SubscriptionData_Subscription}
   */
  merge(other) {
    const copy = new SubscriptionData_Subscription(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    if (other._hasDuration) {
      copy._hasDuration = true;
      copy._duration = other._duration;
    }
    copy._autoMails = this._autoMails.concat(other._autoMails);
    if (other._hasElementalTrialExtraPurchases) {
      copy._hasElementalTrialExtraPurchases = true;
      copy._elementalTrialExtraPurchases = other._elementalTrialExtraPurchases;
    }
    if (other._hasSkillPointsExtraRefills) {
      copy._hasSkillPointsExtraRefills = true;
      copy._skillPointsExtraRefills = other._skillPointsExtraRefills;
    }
    if (other._hasExtendable) {
      copy._hasExtendable = true;
      copy._extendable = other._extendable;
    }
    if (other._hasPersistent) {
      copy._hasPersistent = true;
      copy._persistent = other._persistent;
    }
    if (other._hasElementalTrialFeatureRewardCount) {
      copy._hasElementalTrialFeatureRewardCount = true;
      copy._elementalTrialFeatureRewardCount = other._elementalTrialFeatureRewardCount;
    }
    if (other._hasMineFastClaimCount) {
      copy._hasMineFastClaimCount = true;
      copy._mineFastClaimCount = other._mineFastClaimCount;
    }
    return copy;
  }
}
SubscriptionData_Subscription.default = new SubscriptionData_Subscription();
class SubscriptionData_Subscription_Builder {
  constructor(value) {
    this._value = new SubscriptionData_Subscription(value);
  }
  build() {
    return new SubscriptionData_Subscription(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  setDuration(value) {
    this._value._hasDuration = true;
    this._value._duration = value;
    return this;
  }
  deleteDuration() {
    this._value._hasDuration = false;
    this._value._duration = null;
    return this;
  }
  addAllAutoMails(values) {
    this._value._autoMails = this._value._autoMails.concat(values);
    return this;
  }
  addAutoMails(value) {
    this._value._autoMails = this._value._autoMails.concat([value]);
    return this;
  }
  setAutoMails(index, value) {
    this._value._autoMails = this._value._autoMails.concat();
    this._value._autoMails[index] = value;
    return this;
  }
  clearAutoMails() {
    this._value._autoMails = [];
    return this;
  }
  setElementalTrialExtraPurchases(value) {
    this._value._hasElementalTrialExtraPurchases = true;
    this._value._elementalTrialExtraPurchases = value;
    return this;
  }
  deleteElementalTrialExtraPurchases() {
    this._value._hasElementalTrialExtraPurchases = false;
    this._value._elementalTrialExtraPurchases = null;
    return this;
  }
  setSkillPointsExtraRefills(value) {
    this._value._hasSkillPointsExtraRefills = true;
    this._value._skillPointsExtraRefills = value;
    return this;
  }
  deleteSkillPointsExtraRefills() {
    this._value._hasSkillPointsExtraRefills = false;
    this._value._skillPointsExtraRefills = null;
    return this;
  }
  setExtendable(value) {
    this._value._hasExtendable = true;
    this._value._extendable = value;
    return this;
  }
  deleteExtendable() {
    this._value._hasExtendable = false;
    this._value._extendable = null;
    return this;
  }
  setPersistent(value) {
    this._value._hasPersistent = true;
    this._value._persistent = value;
    return this;
  }
  deletePersistent() {
    this._value._hasPersistent = false;
    this._value._persistent = null;
    return this;
  }
  setElementalTrialFeatureRewardCount(value) {
    this._value._hasElementalTrialFeatureRewardCount = true;
    this._value._elementalTrialFeatureRewardCount = value;
    return this;
  }
  deleteElementalTrialFeatureRewardCount() {
    this._value._hasElementalTrialFeatureRewardCount = false;
    this._value._elementalTrialFeatureRewardCount = null;
    return this;
  }
  setMineFastClaimCount(value) {
    this._value._hasMineFastClaimCount = true;
    this._value._mineFastClaimCount = value;
    return this;
  }
  deleteMineFastClaimCount() {
    this._value._hasMineFastClaimCount = false;
    this._value._mineFastClaimCount = null;
    return this;
  }
}
SubscriptionData_Subscription.Builder = SubscriptionData_Subscription_Builder;
class SubscriptionData_Subscription_WithParent {
  /**
   * @param {SubscriptionData_Subscription} value
   * @param {SubscriptionData_Subscription_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SubscriptionData_Subscription.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get hasDuration() {
    if (this._cachedHasDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedHasDuration = true;
      } else {
        this._cachedHasDuration = this._parent ? this._parent.hasDuration : false;
      }
    }
    return this._cachedHasDuration;
  }
  get duration() {
    if (this._cachedDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedDuration = this._value.duration;
      } else {
        this._cachedDuration = this._parent ? this._parent.duration : this._value.duration;
      }
    }
    return this._cachedDuration;
  }
  get selfAutoMails() {
    if (!this._selfAutoMails) {
      this._selfAutoMails = [];
      for (let i of this._value.autoMails) {
        this._selfAutoMails.push(new SubscriptionData_AutoMail.WithParent(i, null));
      }
    }
    return this._selfAutoMails;
  }
  get inherentAutoMails() {
    if (!this._inherentAutoMails) {
      this._inherentAutoMails = this._parent ? this._parent.autoMails : [];
    }
    return this._inherentAutoMails;
  }
  get autoMails() {
    if (!this._allAutoMails) {
      this._allAutoMails = this._parent ? this._parent.autoMails.concat(this.selfAutoMails) : this.selfAutoMails;
    }
    return this._allAutoMails;
  }
  get hasElementalTrialExtraPurchases() {
    if (this._cachedHasElementalTrialExtraPurchases === undefined) {
      if (this._value.hasElementalTrialExtraPurchases) {
        this._cachedHasElementalTrialExtraPurchases = true;
      } else {
        this._cachedHasElementalTrialExtraPurchases = this._parent ? this._parent.hasElementalTrialExtraPurchases : false;
      }
    }
    return this._cachedHasElementalTrialExtraPurchases;
  }
  get elementalTrialExtraPurchases() {
    if (this._cachedElementalTrialExtraPurchases === undefined) {
      if (this._value.hasElementalTrialExtraPurchases) {
        this._cachedElementalTrialExtraPurchases = this._value.elementalTrialExtraPurchases;
      } else {
        this._cachedElementalTrialExtraPurchases = this._parent ? this._parent.elementalTrialExtraPurchases : this._value.elementalTrialExtraPurchases;
      }
    }
    return this._cachedElementalTrialExtraPurchases;
  }
  get hasSkillPointsExtraRefills() {
    if (this._cachedHasSkillPointsExtraRefills === undefined) {
      if (this._value.hasSkillPointsExtraRefills) {
        this._cachedHasSkillPointsExtraRefills = true;
      } else {
        this._cachedHasSkillPointsExtraRefills = this._parent ? this._parent.hasSkillPointsExtraRefills : false;
      }
    }
    return this._cachedHasSkillPointsExtraRefills;
  }
  get skillPointsExtraRefills() {
    if (this._cachedSkillPointsExtraRefills === undefined) {
      if (this._value.hasSkillPointsExtraRefills) {
        this._cachedSkillPointsExtraRefills = this._value.skillPointsExtraRefills;
      } else {
        this._cachedSkillPointsExtraRefills = this._parent ? this._parent.skillPointsExtraRefills : this._value.skillPointsExtraRefills;
      }
    }
    return this._cachedSkillPointsExtraRefills;
  }
  get hasExtendable() {
    if (this._cachedHasExtendable === undefined) {
      if (this._value.hasExtendable) {
        this._cachedHasExtendable = true;
      } else {
        this._cachedHasExtendable = this._parent ? this._parent.hasExtendable : false;
      }
    }
    return this._cachedHasExtendable;
  }
  get extendable() {
    if (this._cachedExtendable === undefined) {
      if (this._value.hasExtendable) {
        this._cachedExtendable = this._value.extendable;
      } else {
        this._cachedExtendable = this._parent ? this._parent.extendable : this._value.extendable;
      }
    }
    return this._cachedExtendable;
  }
  get hasPersistent() {
    if (this._cachedHasPersistent === undefined) {
      if (this._value.hasPersistent) {
        this._cachedHasPersistent = true;
      } else {
        this._cachedHasPersistent = this._parent ? this._parent.hasPersistent : false;
      }
    }
    return this._cachedHasPersistent;
  }
  get persistent() {
    if (this._cachedPersistent === undefined) {
      if (this._value.hasPersistent) {
        this._cachedPersistent = this._value.persistent;
      } else {
        this._cachedPersistent = this._parent ? this._parent.persistent : this._value.persistent;
      }
    }
    return this._cachedPersistent;
  }
  get hasElementalTrialFeatureRewardCount() {
    if (this._cachedHasElementalTrialFeatureRewardCount === undefined) {
      if (this._value.hasElementalTrialFeatureRewardCount) {
        this._cachedHasElementalTrialFeatureRewardCount = true;
      } else {
        this._cachedHasElementalTrialFeatureRewardCount = this._parent ? this._parent.hasElementalTrialFeatureRewardCount : false;
      }
    }
    return this._cachedHasElementalTrialFeatureRewardCount;
  }
  get elementalTrialFeatureRewardCount() {
    if (this._cachedElementalTrialFeatureRewardCount === undefined) {
      if (this._value.hasElementalTrialFeatureRewardCount) {
        this._cachedElementalTrialFeatureRewardCount = this._value.elementalTrialFeatureRewardCount;
      } else {
        this._cachedElementalTrialFeatureRewardCount = this._parent ? this._parent.elementalTrialFeatureRewardCount : this._value.elementalTrialFeatureRewardCount;
      }
    }
    return this._cachedElementalTrialFeatureRewardCount;
  }
  get hasMineFastClaimCount() {
    if (this._cachedHasMineFastClaimCount === undefined) {
      if (this._value.hasMineFastClaimCount) {
        this._cachedHasMineFastClaimCount = true;
      } else {
        this._cachedHasMineFastClaimCount = this._parent ? this._parent.hasMineFastClaimCount : false;
      }
    }
    return this._cachedHasMineFastClaimCount;
  }
  get mineFastClaimCount() {
    if (this._cachedMineFastClaimCount === undefined) {
      if (this._value.hasMineFastClaimCount) {
        this._cachedMineFastClaimCount = this._value.mineFastClaimCount;
      } else {
        this._cachedMineFastClaimCount = this._parent ? this._parent.mineFastClaimCount : this._value.mineFastClaimCount;
      }
    }
    return this._cachedMineFastClaimCount;
  }
  update(current, parent) {
    const result = new SubscriptionData_Subscription_WithParent(current, parent);
    if (this._selfAutoMails) {
      if (this._value.autoMails === current.autoMails) {
        result._selfAutoMails = this._selfAutoMails;
      } else {
        result._selfAutoMails = [];
        for (let i = 0; i < current.autoMails.length; i++) {
          const oldValue = this._value.autoMails[i];
          if (oldValue) {
            const oldCache = this._selfAutoMails[i];
            if (oldValue === current.autoMails[i]) {
              result._selfAutoMails[i] = oldCache;
            } else {
              result._selfAutoMails[i] = oldCache.update(current.autoMails[i], null);
            }
          } else {
            result._selfAutoMails[i] = new SubscriptionData_AutoMail.WithParent(current.autoMails[i], null);
          }
        }
      }
    }
    return result;
  }
}
SubscriptionData_Subscription_WithParent.default = new SubscriptionData_Subscription_WithParent(SubscriptionData_Subscription.default, null);
SubscriptionData_Subscription.WithParent = SubscriptionData_Subscription_WithParent;
class SubscriptionData_Subscription_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 2,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get duration() {
    if (!this._duration) {
      this._duration = {
        name: "duration",
        Name: "Duration",
        number: 3,
        protoType: 5,
        protoName: "duration",
        type: JsonToInt32,
        options: {
          comments: "Time in seconds",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._duration;
  }
  get autoMails() {
    if (!this._autoMails) {
      this._autoMails = {
        name: "autoMails",
        Name: "AutoMails",
        number: 4,
        protoType: 11,
        protoName: "auto_mails",
        type: SubscriptionData_AutoMail,
        isRepeated: true,
        options: {
          comments: "Time in seconds passed from midnight",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._autoMails;
  }
  get elementalTrialExtraPurchases() {
    if (!this._elementalTrialExtraPurchases) {
      this._elementalTrialExtraPurchases = {
        name: "elementalTrialExtraPurchases",
        Name: "ElementalTrialExtraPurchases",
        number: 5,
        protoType: 5,
        protoName: "elemental_trial_extra_purchases",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._elementalTrialExtraPurchases;
  }
  get skillPointsExtraRefills() {
    if (!this._skillPointsExtraRefills) {
      this._skillPointsExtraRefills = {
        name: "skillPointsExtraRefills",
        Name: "SkillPointsExtraRefills",
        number: 7,
        protoType: 5,
        protoName: "skill_points_extra_refills",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._skillPointsExtraRefills;
  }
  get extendable() {
    if (!this._extendable) {
      this._extendable = {
        name: "extendable",
        Name: "Extendable",
        number: 8,
        protoType: 8,
        protoName: "extendable",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._extendable;
  }
  get persistent() {
    if (!this._persistent) {
      this._persistent = {
        name: "persistent",
        Name: "Persistent",
        number: 9,
        protoType: 8,
        protoName: "persistent",
        type: JsonToBoolean,
        options: {
          comments: "This means the product does not expire",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._persistent;
  }
  get elementalTrialFeatureRewardCount() {
    if (!this._elementalTrialFeatureRewardCount) {
      this._elementalTrialFeatureRewardCount = {
        name: "elementalTrialFeatureRewardCount",
        Name: "ElementalTrialFeatureRewardCount",
        number: 10,
        protoType: 5,
        protoName: "elemental_trial_feature_reward_count",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._elementalTrialFeatureRewardCount;
  }
  get mineFastClaimCount() {
    if (!this._mineFastClaimCount) {
      this._mineFastClaimCount = {
        name: "mineFastClaimCount",
        Name: "MineFastClaimCount",
        number: 12,
        protoType: 5,
        protoName: "mine_fast_claim_count",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mineFastClaimCount;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.displayName,
        this.duration,
        this.autoMails,
        this.elementalTrialExtraPurchases,
        this.skillPointsExtraRefills,
        this.extendable,
        this.persistent,
        this.elementalTrialFeatureRewardCount,
        this.mineFastClaimCount,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDuration",
        Name: "DummyOneofForDuration",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForElementalTrialExtraPurchases",
        Name: "DummyOneofForElementalTrialExtraPurchases",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSkillPointsExtraRefills",
        Name: "DummyOneofForSkillPointsExtraRefills",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForExtendable",
        Name: "DummyOneofForExtendable",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPersistent",
        Name: "DummyOneofForPersistent",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForElementalTrialFeatureRewardCount",
        Name: "DummyOneofForElementalTrialFeatureRewardCount",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMineFastClaimCount",
        Name: "DummyOneofForMineFastClaimCount",
        fields: [
          this.fields[9],
        ],
      });
    }
    return this._oneofs;
  }
}
SubscriptionData_Subscription.descriptor = new SubscriptionData_Subscription_Descriptor();
export class SubscriptionData {
  get descriptor() {
    return SubscriptionData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._subscriptions = [];
  }
  isEmpty() {
    if (this._subscriptions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SubscriptionData) {
      return value;
    }
    return SubscriptionData.fromJson(value);
  }
  static fromJson(json) {
    const result = new SubscriptionData();
    result._subscriptions = JsonToList(json.subscriptions, SubscriptionData_Subscription);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._subscriptions.length > 0) {
      result.subscriptions = ArrayToJson(this._subscriptions, SubscriptionData_Subscription);
    }
    return result;
  }
  /**
   * @returns {SubscriptionData_Subscription[]}
   */
  get subscriptions() {
    return this._subscriptions;
  }
  addSubscriptions(path, value) {
    return {type: 'ADD', path: path.concat(['subscriptions']), value: value.toJson()};
  }
  setSubscriptions(path, value) {
    return {type: 'SET', path: path.concat(['subscriptions']), value: ArrayToJson(value, SubscriptionData_Subscription)};
  }
  setSubscriptionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['subscriptions', key]), value: value.toJson()};
  }
  deleteSubscriptions(path) {
    return {type: 'DELETE', path: path.concat(['subscriptions'])};
  }
  deleteSubscriptionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['subscriptions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "subscriptions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SubscriptionData(this);
              copy._subscriptions = [];        for (let i of value) {
                copy._subscriptions.push(SubscriptionData_Subscription.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new SubscriptionData(this);
              copy._subscriptions = copy._subscriptions.concat([SubscriptionData_Subscription.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._subscriptions.length === 0) {
                return this;
              }
              const copy = new SubscriptionData(this);
              copy._subscriptions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._subscriptions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new SubscriptionData(this);
              copy._subscriptions = copy._subscriptions.slice();
              copy._subscriptions[path[1]] = SubscriptionData_Subscription.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new SubscriptionData(this);
              copy._subscriptions = copy._subscriptions.slice(0, path[1]).concat(copy._subscriptions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._subscriptions.length) {
            return this;
          }
          const oldValue = this._subscriptions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new SubscriptionData(this);
          copy._subscriptions = copy._subscriptions.slice();
          copy._subscriptions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SubscriptionData} other
   * @returns {SubscriptionData}
   */
  merge(other) {
    const copy = new SubscriptionData(this);
    copy._subscriptions = this._subscriptions.concat(other._subscriptions);
    return copy;
  }
}
SubscriptionData.default = new SubscriptionData();
SubscriptionData.AutoMail = SubscriptionData_AutoMail;
SubscriptionData.Subscription = SubscriptionData_Subscription;
class SubscriptionData_Builder {
  constructor(value) {
    this._value = new SubscriptionData(value);
  }
  build() {
    return new SubscriptionData(this._value);
  }
  addAllSubscriptions(values) {
    this._value._subscriptions = this._value._subscriptions.concat(values);
    return this;
  }
  addSubscriptions(value) {
    this._value._subscriptions = this._value._subscriptions.concat([value]);
    return this;
  }
  setSubscriptions(index, value) {
    this._value._subscriptions = this._value._subscriptions.concat();
    this._value._subscriptions[index] = value;
    return this;
  }
  clearSubscriptions() {
    this._value._subscriptions = [];
    return this;
  }
}
SubscriptionData.Builder = SubscriptionData_Builder;
class SubscriptionData_WithParent {
  /**
   * @param {SubscriptionData} value
   * @param {SubscriptionData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SubscriptionData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfSubscriptions() {
    if (!this._selfSubscriptions) {
      this._selfSubscriptions = [];
      for (let i of this._value.subscriptions) {
        this._selfSubscriptions.push(new SubscriptionData_Subscription.WithParent(i, null));
      }
    }
    return this._selfSubscriptions;
  }
  get inherentSubscriptions() {
    if (!this._inherentSubscriptions) {
      this._inherentSubscriptions = this._parent ? this._parent.subscriptions : [];
    }
    return this._inherentSubscriptions;
  }
  get subscriptions() {
    if (!this._allSubscriptions) {
      this._allSubscriptions = this._parent ? this._parent.subscriptions.concat(this.selfSubscriptions) : this.selfSubscriptions;
    }
    return this._allSubscriptions;
  }
  update(current, parent) {
    const result = new SubscriptionData_WithParent(current, parent);
    if (this._selfSubscriptions) {
      if (this._value.subscriptions === current.subscriptions) {
        result._selfSubscriptions = this._selfSubscriptions;
      } else {
        result._selfSubscriptions = [];
        for (let i = 0; i < current.subscriptions.length; i++) {
          const oldValue = this._value.subscriptions[i];
          if (oldValue) {
            const oldCache = this._selfSubscriptions[i];
            if (oldValue === current.subscriptions[i]) {
              result._selfSubscriptions[i] = oldCache;
            } else {
              result._selfSubscriptions[i] = oldCache.update(current.subscriptions[i], null);
            }
          } else {
            result._selfSubscriptions[i] = new SubscriptionData_Subscription.WithParent(current.subscriptions[i], null);
          }
        }
      }
    }
    return result;
  }
}
SubscriptionData_WithParent.default = new SubscriptionData_WithParent(SubscriptionData.default, null);
SubscriptionData.WithParent = SubscriptionData_WithParent;
class SubscriptionData_Descriptor {
  get subscriptions() {
    if (!this._subscriptions) {
      this._subscriptions = {
        name: "subscriptions",
        Name: "Subscriptions",
        number: 1,
        protoType: 11,
        protoName: "subscriptions",
        type: SubscriptionData_Subscription,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._subscriptions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.subscriptions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
SubscriptionData.descriptor = new SubscriptionData_Descriptor();
